import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { DataWrapper } from "./Pages/DataWrapper";
import { AdminAccess } from "./Components/AdminAccess";
import { useUser } from "@spt/bezel/src/Providers/UserProvider";

interface ContainedAppProps {
    SiteAdmins: Array<String> | undefined;
    SetSiteAdmins: Dispatch<SetStateAction<String[] | undefined>>;
    SetCountedUser: Dispatch<SetStateAction<string | undefined>>;
}

export function ContainedApp(props: ContainedAppProps) {
    const [ImpersonationTestingMode, setImpersonationTestingMode] = useState<boolean>(false);

    const user = useUser();

    const _un = user?.AuthedUser?.userPrincipalName.replace("@essex.ac.uk", "");

    useEffect(() => {
        props.SetCountedUser(_un)
    }, [_un]);

    return <>
        <AdminAccess SiteAdmins={props.SiteAdmins} DeniedMessage={
            <DataWrapper
                ShowTestTabs={false}
                SiteAdmins={props.SiteAdmins}
                SetSiteAdmins={props.SetSiteAdmins}
            />
        }>
            <button className="TestButton" onClick={() => { setImpersonationTestingMode(!ImpersonationTestingMode) }}>{
                // Ternary: If we're in Impersonation Testing Mode...
                ImpersonationTestingMode
                    ?
                    "Testing with Impersonation | Click to switch to Tabbed Tests"
                    :
                    "Testing with Tabs | Click to switch to Impersonation Tests"}</button>
            <DataWrapper
                ShowTestTabs={!ImpersonationTestingMode}
                SiteAdmins={props.SiteAdmins}
                SetSiteAdmins={props.SetSiteAdmins}
            />
        </AdminAccess>
    </>
}